import React, { useEffect, useState } from "react";
import CompanyService, { Entities } from "../../../../services/CompanyService";
import { TranslationService } from "../../../../services/TranslationService";
import Dropdown from "../../../shared/components/Dropdown";
import { EntityField, sortEntityFields } from "../../../shared/entities/EntityField";
import { EditProps } from "../EditAction";
import { Field } from "./FieldHelpers";
import { endpointRequest } from "../../../../utils/RequestUtils";
import UserService from "../../../../services/UserService";
import { ActionType } from "../../../../services/ActionService";
import { addIf } from "../../../../utils/Utils";

export const InsertFields = (props: EditProps) => {
    const generateInsertFields = (fields: string[]) => fields.map(x => ({ value: `[${TranslationService.translate[x]}]`, text: TranslationService.translate[x] }))

    const clientFixedFieldOptions = generateInsertFields(['Client'])
    const contactFixedFieldOptions = generateInsertFields(['Contact'])
    const fixedInsertIOFieldOptions = generateInsertFields(['Amount', 'DueAmount', "NotDueAmount"])
    // const fixedUserFields = generateInsertFields(["UserFirstName", "UserLastName", "UserEmail", "UserSignature"])

    const hasSegmentsWithUser = props.data.segments?.some(el => el.UserID);

    const clientAdditionalFieldOptions =
        [...CompanyService.getAdditionalDefinitionsFiltered(Entities.Client).map(x => new EntityField(x)),]
            .sort(sortEntityFields(CompanyService.getPersonSortedFields().split(",")))
            .map(x => ({ value: `[${x.title}]`, text: x.title ?? '' }));

    const fixedFields = React.useMemo(() => {
        let fields: any[] = [
            { text: TranslationService.translate.EmailInsertField, value: "" },
        ];
        switch (props.data.Type) {
            case ActionType.MailSend:
                fields = [
                    ...fields,
                    ...clientFixedFieldOptions,
                    ...contactFixedFieldOptions,
                    ...generateInsertFields(['Notes']),
                    ...clientAdditionalFieldOptions,
                    ...fixedInsertIOFieldOptions,
                    ...[{ value: `[${TranslationService.translate.Invoices}]`, text: TranslationService.translate.InvoiceListR }],
                    ...addIf(CompanyService.getSetting("customerportalenabled"), { value: '[Portal] ', text: TranslationService.translate.CustomerPortal }),
                    // // fixedUserFields,
                    // ...generateInsertFields(['FollowUpMail']),
                    ...addIf(Boolean(hasSegmentsWithUser), { value: `[${TranslationService.translate['UserSignature']}]`, text: TranslationService.translate['UserSignature'] }),
                ]
                break;
            case ActionType.ActionSMSSend:
                fields = [
                    ...fields,
                    ...clientFixedFieldOptions,
                    ...contactFixedFieldOptions,
                    ...fixedInsertIOFieldOptions,
                    ...generateInsertFields(['ClaimableAmount']),
                    { value: '[linkportal] ', text: TranslationService.translate.CustomerPortal },
                    // ...fixedUserFields
                ]
                break;
            case ActionType.ActionSendLetter:
                fields = [
                    ...fields,
                    ...clientFixedFieldOptions,
                    ...contactFixedFieldOptions,
                    ...clientAdditionalFieldOptions,
                    ...fixedInsertIOFieldOptions,
                    ...generateInsertFields(['Invoices', 'Date'])
                ]
                break;
            default:
                fields = [];
                break;
        }
        return fields;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data.Type, clientFixedFieldOptions, contactFixedFieldOptions, clientAdditionalFieldOptions, fixedInsertIOFieldOptions]);

    const onChange = (value: string) => (value?.length > 0) && props.setData(old => ({ ...old, Content: (old.Content ?? "") + value }));

    return (
        <Field title={TranslationService.translate.AddMoreFields}>
            <Dropdown onChange={onChange} items={fixedFields} value={""} />
        </Field>);
}

export const InsertFieldsOnly = (props: EditProps) =>
    <div className="row">
        <InsertFields {...props} />
    </div>


export const InsertFieldsSignature = (props: EditProps) => {
    const [signatures, setSignatures] = useState<{ value: number, text: string }[]>([]);
    useEffect(() => {
        endpointRequest(() => UserService.getSignatures(),
            x => setSignatures(x.map(y => ({ value: y.SignatureID, text: UserService.getUserName(y.UserID) ?? "" })))
        )
    }, []);
    return (
        <div className="row">
            <InsertFields {...props} />
            {signatures.length > 0 && <Field title={TranslationService.translate.Signature}>
                <Dropdown onChange={props.propGen.num.notRequired("Mail_SignatureID").onChange} items={signatures} optionLabel={TranslationService.translate.None} value={props.data.Mail_SignatureID} />
            </Field>}
        </div>
    )
}